// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// react-snap prerenders each route to static HTML, which is what search engines
// and social scrapers read (and what paints first on slow connections). The
// browser then renders the live app with createRoot. We intentionally do NOT
// hydrate: the prerendered snapshot is built without live API data, so hydration
// would mismatch the data-filled client render and throw React #418. createRoot
// cleanly mounts the live app over the prerendered markup instead.
const rootElement = document.getElementById('root');
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
